<template>
  <v-card-text>
    <v-layout row wrap>
      <v-flex xs12 sm4="sm4">
        <v-text-field v-model="search" outlined dense append-icon="mdi-magnify" label="Search" single-line="single-line"
          hide-details clearable="clearable">
        </v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex v-if="Invoices" shrink class="text-h4">
        {{ Invoices.length }}
      </v-flex>
    </v-layout>
    <v-data-table class="mt-4" :loading="loading" :search="search" :headers="headers" :items="Invoices"
      :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
      <template v-slot:item="{ item }">
        <tr class="pointer" @click="viewInvoice(item)">
          <td class="text-left small-td pointer">
            <div>{{ item.InvoiceID }}</div>
          </td>

          <td class="text-left small-td pointer">
            <div>{{ item.InvoiceDate | moment("MM/DD/YYYY hh:mm A") }}</div>
            <div class="text-capitalize text--disabled font-italic">

              <!-- <v-avatar size="10" :color="item.EmployeeSelectedColor" ></v-avatar>  -->
              - {{ item.FullName }}
            </div>
          </td>
          <td class="text-left small-td pointer">
            <div>{{ item.AccountName }}</div>
            <div v-if="item.ItemCount > 1" class="text-capitalize text--disabled font-italic">{{ item.ItemCount }} Items
            </div>
            <!-- <div class="text-capitalize text--disabled font-italic">- {{ item.EmployeeName }}</div> -->
          </td>
          <td class="text-right small-td pointer">{{ item.Cash | currency }}</td>
          <td class="text-right small-td pointer">
            <div>{{ item.CreditCard | currency }}</div>
            <div v-if="item.Last4CardDigits">-{{ item.Last4CardDigits }}</div>
          </td>
          <td class="text-right small-td pointer">
            <div>{{ item.DebitCard | currency }}</div>
            <div v-if="item.Last4DebitCardDigits">-{{ item.Last4DebitCardDigits }}</div>
          </td>
          <td class="text-right small-td pointer">{{ item.DueAmount | currency }}</td>
          <td class="text-left small-td pointer">
            <div>{{ item.InvoiceTypeName }}</div>

          </td>
          
          <td class="text-left small-td pointer">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ item.Notes }}</span>
              </template>
              <span>{{ item.Notes }}</span>
            </v-tooltip>

          </td>


        </tr>
      </template>

    </v-data-table>
  </v-card-text>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateTimePicker from '@/components/DateTimePicker.vue'
import reportService from '@/pages/Report/service.js'

export default {
  name: 'invoice-list',
  props: ['location', 'dateTime'],
  data() {
    return {
      search: '',
      loading: false,
      Invoices: [],
      sortBy: "OpenDate",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: 'ID',
          align: "left",
          sortable: true,
          value: "InvoiceID"
        },
        {
          text: 'Date',
          align: "left",
          sortable: true,
          value: "InvoiceDate"
        },
        {
          text: 'Customer',
          align: "left",
          sortable: true,
          value: "AccountName"
        },

        {
          text: 'Cash',
          align: 'right',
          value: "cash",
          sortable: true
        },
        {
          text: 'Credit',
          align: 'right',
          value: "CreditCard",
          sortable: true
        },
        {
          text: 'Debit',
          align: 'right',
          value: "DebitCard",
          sortable: true
        },
        {
          text: 'Total',
          align: 'right',
          value: "DueAmount",
          sortable: true
        },
        {
          text: 'Type',
          value: "InvoiceTypeName",
          sortable: true
        },
        {
          text: 'Notes',
          value: "Notes",
          sortable: false
        },
        {
          text: '',
          value: "FullName",
          align: ' d-none',
          sortable: false
        },
        {
          text: 'Last4DebitCardDigits',
          value: "Last4DebitCardDigits",
          align: ' d-none',
          sortable: false
        },
        {
          text: 'Last4CardDigits',
          value: "Last4CardDigits",
          align: ' d-none',
          sortable: false
        },

      ],
    }
  },
  watch: {
    dateTime(val) {
      this.getInvoiceList()
    },
    location(val) {
      this.setSelectedLocation(val)
      this.getInvoiceList()
    }
  },
  computed: {
    ...mapGetters('location', ['locations']),
    ...mapGetters('report', ['batchList', 'selectedLocation'])
  },
  components: {
    DateTimePicker,
  },
  created() {
    this.getInvoiceList()
    // if (this.$route.params.location) {
    //   this.location = this.$route.params.location
    //   this.getInvoiceList()
    // } else {
    //   if (this.selectedLocation) {
    //     this.location = this.selectedLocation
    //   }
    // }
  },
  methods: {
    ...mapActions('report', ['setSelectedLocation']),
    viewInvoice(invoice) {
      // const hashId = hashids.encode(invoice.id);
      // this.$router.push({ name: 'Batch-selection', params: { location: this.selectedLocation } });

      const routeData = this.$router.resolve({
        path: `/location/${this.location.storeID}/invoice/${invoice.InvoiceID}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    closeDatePicker() {
      this.getInvoiceList()
    },
    getInvoiceList() {
      if (!this.location) return false

      if (!this.dateTime.start) return false
      this.Invoices = []
      this.loading = true
      return reportService
        .getInvoices(this.location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
        .then(response => {
          console.log("getInvoiceList", response);
          this.loading = false
          this.Invoices = response.data
          // this.setBatchList(this.Batches)
          return response;
        }).catch(error => {
          this.loading = false
        })

    }
  }
}
</script>

<style scoped>
</style>